import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Header from './components/layout/Header';
import Footer from './components/layout/Footer';
import HomePage from './pages/HomePage';
import DementiaCarePage from './pages/Services/DementiaCarePage';
import PrePostOpCarePage from './pages/Services/PrePostOpCarePage';
import PhysiotherapyPage from './pages/Services/PhysiotherapyPage';
import BasicSupportiveCarePage from './pages/Services/BasicSupportiveCarePage';
import AdvancedNursingCarePage from './pages/Services/AdvancedNursingCarePage';
import WoundDressingPage from './pages/Services/WoundDressingPage';
import About from './pages/About';
import ContactForm from './components/sections/ContactForm';
import ScrollToTop from './components/layout/ScrollToTop';
import ServicesPage from "./pages/ServicesPage";
import '@fortawesome/fontawesome-free/css/all.min.css';
import './App.css';
// FAQ Page
const FAQPage = () => {
  const faqs = [
    { q: "What services do you provide?", a: "We offer basic supportive care, advanced nursing care, dementia care, pre & post-op care, wound dressing, and physiotherapy." },
    { q: "Are your caregivers certified?", a: "Yes, all our caregivers are licensed and certified professionals." },
    { q: "Do you offer 24/7 support?", a: "Yes, we provide round-the-clock support depending on the chosen service." },
    { q: "How can I request a service?", a: "You can contact us through the Contact page or call our support line." },
    { q: "Do you accept insurance?", a: "Yes, we work with most major insurance providers. Please reach out for details." },
    { q: "Can I customize the care plan?", a: "Absolutely. We create personalized care plans tailored to each client." },
    { q: "Do you provide free consultations?", a: "Yes, we offer free initial consultations to assess your needs." },
    { q: "What areas do you serve?", a: "We provide services across multiple locations. Contact us for availability in your area." },
    { q: "Can I change caregivers if needed?", a: "Yes, if you are not comfortable, we will assign another caregiver promptly." },
    { q: "How do I get started?", a: "Simply reach out via our website form or call us directly to begin the process." },
  ];

  return (
    <div className="page-container">
      <h1 className="page-title">Frequently Asked Questions</h1>
      <div className="faq-list">
        {faqs.map((faq, idx) => (
          <div key={idx} className="faq-item">
            <h4 className="faq-question">{faq.q}</h4>
            <p className="faq-answer">{faq.a}</p>
          </div>
        ))}
      </div>
    </div>
  );
};

// Privacy Policy Page
const PrivacyPolicyPage = () => (
  <div className="page-container">
    <h1 className="page-title">Privacy Policy</h1>
    <p>
      Our privacy policy explains how we collect, use, and protect your personal information. 
      We are committed to maintaining transparency and safeguarding your privacy.
    </p>
  </div>
);


const App = () => {
  //   const location = useLocation();

  // // pages where you DON'T want reviews
  // const hideOn = ["/faq", "/about", "/contact"];
  const services = [
    {
      icon: <i className="fas fa-hands-helping"></i>,
      title: "Basic Supportive Care",
      description: "Compassionate assistance with daily activities and essential supportive care.",
      link: "/basic-supportive-care"
    },
    {
      icon: <i className="fas fa-user-nurse"></i>,
      title: "Advanced Nursing Care",
      description: "Professional nursing services including catheterization, Ryles tube, and IV injections.",
      link: "/advanced-nursing-care"
    },
    {
      icon: <i className="fas fa-brain"></i>,
      title: "Dementia Care",
      description: "Specialized care for patients with dementia, ensuring comfort and safety.",
      link: "/dementia-care"
    },
    {
      icon: <i className="fas fa-procedures"></i>,
      title: "Pre & Post-Op Care",
      description: "Comprehensive care before and after surgeries for smooth recovery.",
      link: "/pre-post-op-care"
    },
    {
      icon: <i className="fas fa-band-aid"></i>,
      title: "Wound Dressing",
      description: "Expert wound care and dressing services to support healing and prevent infection.",
      link: "/wound-dressing"
    },
    {
      icon: <i className="fas fa-dumbbell"></i>,
      title: "Physiotherapy",
      description: "Personalized physiotherapy sessions to restore mobility, strength, and function.",
      link: "/physiotherapy"
    }
  ];

  return (
    <Router>
      <div className="app-container">
        <Header />
        <main>
          <ScrollToTop />
          <Routes>
            <Route path="/" element={<HomePage services={services} />} />
            {/* Individual Service Pages */}
            <Route path="/basic-supportive-care" element={<BasicSupportiveCarePage />} />
            <Route path="/advanced-nursing-care" element={<AdvancedNursingCarePage />} />
            <Route path="/dementia-care" element={<DementiaCarePage />} />
            <Route path="/pre-post-op-care" element={<PrePostOpCarePage />} />
            <Route path="/wound-dressing" element={<WoundDressingPage />} />
            <Route path="/physiotherapy" element={<PhysiotherapyPage />} />
            {/* Static Pages */}
            <Route path="/about" element={<About />} />
            <Route path="/contact" element={<ContactForm />} />
            {/* Extra Pages */}
            <Route path="/services" element={<ServicesPage />} />
            <Route path="/faq" element={<FAQPage />} />
            <Route path="/privacy" element={<PrivacyPolicyPage />} />
          </Routes>
        </main>
         {/* Show reviews only if not in hideOn
      {!hideOn.includes(location.pathname) && <PatientReviews />} */}

        <Footer />
        
        {/* ✅ WhatsApp Floating Button - Fixed positioning */}
        <a
          href="https://wa.me/918270007174"
          className="whatsapp_float"
          target="_blank"
          rel="noopener noreferrer"
          aria-label="Chat on WhatsApp"
        >
          <i className="fab fa-whatsapp whatsapp-icon"></i>
        </a>
      </div>
    </Router>
  );
};

export default App;